import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=51eff0e6&scoped=true&"
import script from "./fileTable.vue?vue&type=script&lang=js&"
export * from "./fileTable.vue?vue&type=script&lang=js&"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=51eff0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eff0e6",
  null
  
)

export default component.exports